import { useState, useEffect, useContext } from "react";
import { countTasksForJourneys } from "apps/journeys/utils/helpers";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import TaskCount from "../../task-count/task-count";
import checkIcon from "images/check.svg";

const FIELDS_TO_INCLUDE = ["total", "email", "calls", "notEmailOrPhone", "completed"]; // "notEmailOrPhone" is labeled "Other"

const JourneyTaskCount = () => {
  const { journeys } = useContext(JourneysContext);
  const [showIcon, setShowIcon] = useState(false);
  const [totals, setTotals] = useState({});
  const [title, setTitle] = useState("");
  const [data, setData] = useState({});

  useEffect(() => {
    const counts = countTasksForJourneys(journeys, FIELDS_TO_INCLUDE);
    const { completed, ...rest } = counts;
    setData(rest); // don't care about completed here
    setTotals(counts);
  }, [journeys]);

  useEffect(() => {
    const { total } = totals;
    const { completed } = totals;

    let newTitle = "";
    if (total === 0 && completed === 0) {
      newTitle = "You have no cadence steps due";
      setShowIcon(false);
    } else if (total > 0) {
      newTitle = null;
      setShowIcon(false);
    } else {
      newTitle = "You completed all of your cadence steps!";
      setShowIcon(true);
    }
    setTitle(newTitle);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totals.total, totals.completed]);

  return <TaskCount title="Cadence Steps" subTitle={title} showIcon={showIcon} icon={checkIcon} data={data} />;
};

export default JourneyTaskCount;
